import React from 'react';
import { StyledGroup, StyledCheckbox, OuterDiv } from 'components/UIElements/FilterCheckBoxCompSkill/style';
import Flex from 'components/Flex';

const FilterCheckBoxCompSkill = ({
  value,
  options,
  onChange,
  valueParam = 'value',
  labelParam = 'label',
  onChangeCheck,
}) => {

  const getLabel = (item) => {
    if (item[labelParam] === 'twelfth') {
      return '12th Grade';
    } else if (item[labelParam] === 'ug') {
      return `UG - ${item?.degree}`;
    } else if (item[labelParam] === 'pg') {
      return `PG - ${item?.degree}`;
    } else if (item[labelParam] === 'phd') {
      return `PHD - ${item?.degree}`;
    } else if (item[labelParam] === 'p_g_diploma') {
      return `PG DIPLOMA - ${item?.degree}`;
    } else if (item[labelParam] === 'diploma') {
      return `DIPLOMA - ${item?.degree}`;
    } else if (item[labelParam] && typeof item[labelParam] === 'string') {
      return item[labelParam].charAt(0).toUpperCase() + item[labelParam].slice(1);
    }

    return item[labelParam];
  };


  return (
    <OuterDiv>
   <StyledGroup value={value} onChange={onChange}>
        {options?.map((item, index) => (
          <Flex spaceBetween centerVertically key={index+"option"}>
            <StyledCheckbox
              isAdded={item?.isAdded}
              value={item[valueParam]}
              disabled={item?.isAdded}
              label={getLabel(item)} 
              onChange={onChangeCheck}
            />
          </Flex>
        ))}
      </StyledGroup>
    </OuterDiv>
  )
}

export default FilterCheckBoxCompSkill